export type TpaStatusVariant = 'default' | 'secondary' | 'destructive' | 'outline'

export type TpaStatusMeta = { labelKey: string; variant: TpaStatusVariant }

export function tpaStatusMeta(status: string | null | undefined): TpaStatusMeta {
    switch (status) {
        case 'active':
            return { labelKey: 'tagadapayRouter.statusActive', variant: 'default' }
        case 'paused':
            return { labelKey: 'tagadapayRouter.statusPaused', variant: 'secondary' }
        case 'banned':
            return { labelKey: 'tagadapayRouter.statusBanned', variant: 'destructive' }
        case 'closed':
            return { labelKey: 'tagadapayRouter.statusClosed', variant: 'destructive' }
        case 'migrating':
            return { labelKey: 'tagadapayRouter.statusMigrating', variant: 'secondary' }
        case 'migrated':
            return { labelKey: 'tagadapayRouter.statusMigrated', variant: 'secondary' }
        default:
            return { labelKey: 'tagadapayRouter.statusPending', variant: 'outline' }
    }
}

export function tpaIdFromProcessor(processor: {
    tagadapayAccountId?: string | null
    options?: Record<string, unknown> | null
} | null | undefined): string | null {
    if (!processor) return null
    if (typeof processor.tagadapayAccountId === 'string' && processor.tagadapayAccountId) {
        return processor.tagadapayAccountId
    }
    const fromOptions = processor.options?.tagadapayAccountId
    return typeof fromOptions === 'string' && fromOptions ? fromOptions : null
}
